export default "__VITE_PUBLIC_ASSET__a36ed0c1__"